
import React from 'react';
import { Progress } from '@/components/ui/progress';

type RiskLevel = 'Super Safe' | 'Low Risk' | 'Moderate Risk' | 'High Risk' | 'Super High Risk';

interface RiskColorChartProps {
  riskLevel: RiskLevel;
}

const RiskColorChart: React.FC<RiskColorChartProps> = ({ riskLevel }) => {
  // Map each risk level to a progress percentage value (0-100)
  const getRiskProgressValue = (level: RiskLevel): number => {
    switch(level) {
      case 'Super Safe': return 10;
      case 'Low Risk': return 30;
      case 'Moderate Risk': return 50;
      case 'High Risk': return 70;
      case 'Super High Risk': return 90;
    }
  };

  // Get color classes based on risk level for the active segment
  const getActiveColorClass = (level: RiskLevel): string => {
    switch(level) {
      case 'Super Safe': return 'bg-green-500';
      case 'Low Risk': return 'bg-indigo-500';
      case 'Moderate Risk': return 'bg-amber-500';
      case 'High Risk': return 'bg-orange-500';
      case 'Super High Risk': return 'bg-red-500';
    }
  };

  const progressValue = getRiskProgressValue(riskLevel);
  const activeColorClass = getActiveColorClass(riskLevel);

  return (
    <div className="mt-6 mb-8">
      <div className="flex justify-between mb-3 text-xs text-gray-600 px-2">
        <span className="text-center w-1/5">Super Safe</span>
        <span className="text-center w-1/5">Low Risk</span>
        <span className="text-center w-1/5">Moderate Risk</span>
        <span className="text-center w-1/5">High Risk</span>
        <span className="text-center w-1/5">Super High Risk</span>
      </div>
      
      <div className="relative h-3 rounded-full overflow-hidden bg-gray-200">
        {/* Color segments */}
        <div className="absolute inset-0 flex">
          <div className="flex-1 bg-green-500"></div>
          <div className="flex-1 bg-indigo-500"></div>
          <div className="flex-1 bg-amber-500"></div>
          <div className="flex-1 bg-orange-500"></div>
          <div className="flex-1 bg-red-500"></div>
        </div>
        
        {/* Indicator */}
        <div 
          className="absolute h-5 w-3 bg-white border border-gray-300 rounded-full -mt-1 transform -translate-x-1/2" 
          style={{ left: `${progressValue}%` }}
        ></div>
      </div>
    </div>
  );
};

export default RiskColorChart;
